import React from 'react';
import { useTranslation } from 'react-i18next';


const Home = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h1>Naviauth</h1>
      <p>{t('welcome')}</p>
      <p>Naviauth is Navien OAuth 2.0</p>
    </div>
  );
};

export default Home;